import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // 会员中心
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '会员中心',
      keepAlive: false
    }
  },
  // 会员支付
  {
    path: '/vippay',
    name: 'vipPay',
    component: () => import(/* webpackChunkName: "about" */ '../views/VIPPay.vue')
  },
  // IOS会员支付
  {
    path: '/vipiospay',
    name: 'vipiosPay',
    component: () => import(/* webpackChunkName: "about" */ '../views/VIPiosPay.vue')
  },
  // 会员福利社
  {
    path:'/vipwelfare',
    name:'vipWelfare',
    component: () => import(/* webpackChunkName: "about" */ '../views/VIPWelfare.vue')
  },
  // 会员福利详情
  {
    path:'/vipcoupon',
    name:'vipcoupon',
    component:()=>import('../views/VIPCoupon.vue')
  },
  // 会员专享视频
  {
    path:'/vipvideo',
    name:'vipVideo',
    component: () => import(/* webpackChunkName: "about" */ '../views/VIPVideo.vue')
  },
  // 会员成长体系
  {
    path:'/vipgrow',
    name:'vipGrow',
    component:()=>import('../views/VIPGrow.vue')
  },
  // 自动续费管理
  {
    path:'/viprenew',
    name:'vipRenew',
    component:()=>import('../views/VIPRenew.vue')
  },
  // 会员记录
  {
    path:'/viprecord',
    name:'vipRecord',
    component:()=>import('../views/VIPRecord.vue')
  },
  // 会员兑换
  {
    path:'/vipexchange',
    name:'vipExchange',
    component:()=>import('../views/VIPExchange.vue')
  },
  // 巅峰赛事包
  {
    path:'/vipbag',
    name:'vipBag',
    component:()=>import('../views/VIPBag.vue')
  },
  // app会员支付页中间页
  {
    path:'/vipmidd',
    name:'vipMiddle',
    component:()=>import('../views/VIPMiddleDeatil.vue')
  },
  // 奥沙利文
  {
    path:'/vipstar',
    name:'vipStar',
    component:()=>import ('../views/VIPStar.vue')
  },
  // 支付合并页
  {
    path:'/vipmiddpay',
    name:"vipMiddpay",
    component:()=>import ('../views/VIPMiddlePay.vue')
  },
  // 支付成功
  // {
  //   path:'/vipmiddpaysucc',
  //   name:"vipmiddpaysucc",
  //   component:()=>import ('../views/VIPMiddlePaySucc.vue')
  // },
  // 会员退费
  {
    path:'/viprefund',
    name:"vipFefund",
    component:()=>import ('../views/VIPRefund.vue')
  },
  // 申请退费
  {
    path:'/applyrefund',
    name:"applyRefund",
    component:()=>import ('../views/VIPApplyRefund.vue')
  },
  // 会员退费记录
  {
    path:'/refundhistory',
    name:"refundHistory",
    component:()=>import ('../views/VIPRefundHistory.vue')
  }, 
  // 会员退费详情
  {
    path:'/viprefundinfo',
    name:"vipRefundInfo",
    component:()=>import ('../views/VIPRefundInfo.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: "h5vip",
  // base: "h5vips",
  routes,
  
})
router.beforeEach((to,from,next) => {
  window.scrollTo(0,0)
  next()
})
export default router
